import mergePaginatedUsers from './mergePaginatedUsers';
import mergeHistoryEventsData from './mergeHistoryEventsData';
import mergeWorkspacePaginatedTasks from './mergeWorkspacePaginatedTasks';

/**
 * This file hosts definitions for merging paginated results with Apollo
 * Docs: // https://www.apollographql.com/docs/react/pagination/core-api/#merging-paginated-results
 */

// `merge()` is only called if query vars listed within `keyArgs` remain the same
// if a query variable not listed in `keyArgs` is updated on `fetchMore`, `merge()` is called
export const QueryPolicies = {
  preboarderTeamMembers: {
    keyArgs: ['userId', 'userTeamId', 'managerId', 'managerTeamId'],
    merge: (existing = {}, incoming) => mergePaginatedUsers(existing, incoming),
  },
  preboarderNewStarters: {
    keyArgs: ['userId', 'userStartDate'],
    merge: (existing = {}, incoming) => mergePaginatedUsers(existing, incoming),
  },
  teamUsers: {
    keyArgs: ['managerId', 'orderByColumn', 'orderByDirection', 'page', 'perPage'],
    merge: (existing, incoming) => incoming,
  },
  paginatedUserDocuments: {
    keyArgs: ['sessionUserId', 'viewedUserId'],
    merge: (_, incoming) => incoming,
  },
  paginatedUsersByTeamId: {
    keyArgs: ['teamId'],
    merge: (existing = {}, incoming) => mergePaginatedUsers(existing, incoming),
  },
  historyEventsData: {
    keyArgs: ['term'],
    merge: (existing, incoming, { readField }) => mergeHistoryEventsData(existing, incoming, readField),
  },
  customTableUserSnapshotActivities: {
    keyArgs: false,
    merge: (existing = [], incoming) => [...existing, ...incoming],
  },
  dashboard: {
    keyArgs: false,
    merge: (existing = {}, incoming) => ({ ...existing, ...incoming }),
  },
  timeOff: {
    merge: true,
  },
  workspacePaginatedTasks: {
    keyArgs: ['workspaceId'],
    merge: (existing = {}, incoming) => mergeWorkspacePaginatedTasks(existing, incoming),
  },
};

export const CompanyPolicies = {
  keyFields: [],
};

export const DocumentRequestPolicies = {
  keyFields: ['id', 'type'],
};

export const DocumentPolicies = {
  keyFields: ['id', 'type'],
};

export { default as UserPolicies } from './UserPolicies';
